export const showDownloadOverlay = () => (
  (dispatch) => {
    dispatch({
      type: 'SHOW_DOWNLOAD_ARROW_OVERLAY',
    });
  }
);

export const hideDownloadOverlay = () => (
  (dispatch) => {
    dispatch({
      type: 'HIDE_DOWNLOAD_ARROW_OVERLAY',
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/download-overlay/DownloadOverlayActions.jsx